import React, { useState, useEffect, useCallback } from 'react'
import { BREAKPOINT } from 'Constants'

const getSizeType = () => {
  if (BREAKPOINT.small > window.innerWidth) return 'sm'
  if (BREAKPOINT.medium > window.innerWidth) return 'md'
  return 'lg'
}

const useWindowType = () => {
  const [sizeType, setSizeType] = useState(getSizeType())

  const handleResize = useCallback(() => {
    setSizeType(getSizeType())
  }, [setSizeType])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return [sizeType]
}

export default useWindowType
